import React from 'react';
import styled, { keyframes } from 'styled-components';

const load = keyframes`
   from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const StyledLoader = styled.div<Props>`
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  margin: 0 auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 0.4rem solid rgba(255, 255, 255, 0.2);
  border-right: 0.4rem solid rgba(255, 255, 255, 0.2);
  border-bottom: 0.4rem solid rgba(255, 255, 255, 0.2);
  border-left: 0.4rem solid #ffffff;
  transform: translateZ(0);
  animation: ${load} 1.1s infinite linear;
  &:after {
    border-radius: 50%;
    width: 2rem;
    height: 2rem;
    content: '';
  }
`;

interface Props {
  background?: string;
  spinnerColor?: string;
}

export const Loader: React.FC<Props> = ({ background = '#FFF', spinnerColor = '#000' }) => {
  return <StyledLoader background={background} spinnerColor={spinnerColor} />;
};
